import { render, staticRenderFns } from "./ContactCreateUpdate.vue?vue&type=template&id=04c0ce4e&"
import script from "./ContactCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./ContactCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports